import Routes from "@/common/router/Routes";
import CalculationdRouter from "@/context/calculation/router/CalculationRouter";

export default class CalculationRoutes extends Routes {
  private static _instance: CalculationRoutes;
  public static instance(): CalculationRoutes {
    if (!CalculationRoutes._instance) {
      CalculationRoutes._instance = new CalculationRoutes();
    }
    return CalculationRoutes._instance;
  }
  private constructor() {
    super({
      label: "Obliczenia",
      router: CalculationdRouter.instance(),
      lazyPage: () => import("@/context/calculation/page/CalculationPage.vue"),
      lazyCreate: () =>
        import("@/context/calculation/containers/CalculationRequestFormContainer.vue"),
      lazyList: () =>
        import("@/context/calculation/containers/CalculationRequestListContainer.vue"),
      lazyUpdate: () =>
        import("@/context/calculation/containers/CalculationRequestFormContainer.vue"),
      lazyShow: () => import("@/context/calculation/containers/CalculationRequestShowContainer.vue")
    });

    this.addChild({
      path: "anomaly_removal",
      name: "anomaly_removal",
      label: "Usuwanie anomalii",
      visible: true,
      component: () => import("@/context/calculation/containers/AnomalyRemovalFormContainer.vue"),
      url: `${this.router.basePath}/anomaly_removal`
    });
  }
}
